import React from "react";
import useModalQueue from "./useModalQueue";

const ModalCloseButton = ({
  modalName = "",
  onClose = () => {}
}) => {
  const {closeModal} = useModalQueue(modalName);

  const onCloseClick = () => {
    closeModal();
    onClose();
  };

  return <div className="close-btn cursor-pointer" onClick={onCloseClick}>
    <img src={"/icons/rx-cross-1-black.svg"} alt={"close"}/>
  </div>;
};

export default ModalCloseButton;
